import { ReactNode } from "react";

import Loading from "web/Layout/Common/Loading";

import useSubscriptionsView from "web/hooks/useSubscriptionsView";

interface SubscriptionViewSwitchProps {
  oldUI: ReactNode;
  newUI: ReactNode;
}

const SubscriptionViewSwitch: React.FC<SubscriptionViewSwitchProps> = ({
  oldUI = null,
  newUI = null,
}) => {
  const { enableNewSubscriptionUI, isLoading } = useSubscriptionsView();

  if (isLoading) {
    return <Loading />;
  }

  if (enableNewSubscriptionUI && newUI) {
    return <>{newUI}</>;
  }

  return <>{oldUI}</>;
};

export default SubscriptionViewSwitch;
